
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/[slug]",
      function () {
        return require("private-next-pages/3catinfo/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/[slug]"])
      });
    }
  